import React, { useEffect, useState } from "react";
import "../../assets/css/Section4.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { GET_ALL_GAMES } from "../../service/admin.service";
import ReusableCard from "../ReusableCard";

/* ===== Skeleton Card ===== */
const GameSkeleton = () => (
  <div className="tw-bg-white tw-rounded-xl tw-shadow-sm tw-p-4 tw-animate-pulse">
    <div className="tw-h-5 tw-w-40 tw-bg-gray-200 tw-rounded tw-mb-3" />
    <div className="tw-h-4 tw-w-24 tw-bg-gray-200 tw-rounded tw-mb-2" />
    <div className="tw-h-4 tw-w-32 tw-bg-gray-200 tw-rounded" />
  </div>
);

const AvailableGames = () => {
  const [getData, setgetData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getResponseData = async () => {
    setLoading(true);
    try {
      const res = await GET_ALL_GAMES();
      if (res.status) {
        setgetData(res?.data?.filter((item) => item.activeStatus === true) || []);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getResponseData();
  }, []);

  return (
    <div>
      {loading ? (
        /* ===== Skeleton Grid ===== */
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <GameSkeleton key={i} />
          ))}
        </div>
      ) : (
        <ReusableCard
          GameData={getData}
          title="Today's Market Results"
          showPana={true}
        />
      )}
    </div>
  );
};

export default AvailableGames;